var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWallet7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5041 10C18.2551 10 14 14.1915 14 19.3619V30.2677C14 35.4381 18.2551 39.6296 23.5041 39.6296H40.3194V100.638C40.3194 105.809 44.5745 110 49.8234 110H60.895C66.1439 110 70.3991 105.809 70.3991 100.638V30.347C70.3993 30.3207 70.3995 30.2942 70.3995 30.2677V19.3619C70.3995 14.1915 66.1443 10 60.8952 10H49.8234H23.5041Z",
    fill: "#0097FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9597 39.6296C101.266 39.6296 108 32.9968 108 24.8148C108 16.6328 101.266 10 92.9597 10C84.6534 10 77.9199 16.6328 77.9199 24.8148C77.9199 32.9968 84.6534 39.6296 92.9597 39.6296Z",
    fill: "#0097FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet7);
export default __webpack_public_path__ + "static/media/icon-wallet-7.de30f0e7bae17235d7ba9e3aa05e5536.svg";
export { ForwardRef as ReactComponent };